jQuery( document ).ready(function($) {
    var slider = $('.ct_headerslider:not(.admin_preview)').each(function() {
        $(this).slick({
            arrows: false,
            fade: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 7000,
            pauseOnHover:false,
            infinite: true,
            fade: true,
        });
    });
});
